import { VF_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/v-f-dropdown';
import {
  INLINE_ERRORS,
  commonValidation,
  cleanUpFieldErrors,
  getDefaultFieldErrors,
} from 'AppSrc/core/components/forms/form-base-components/utility/common-validation';
import { CATEGORISED_DROPDOWN } from 'AppSrc/core/components/forms/form-base-components/sub-components/drop-down-components/templates/dropdown-templates';
import {
  currentSelectedNetwork,
} from 'AppSrc/core/components/forms/form-types/create-crq/common-logic';
import { WORK_INFORMATION_TYPE } from './work-information-item-constants';
import { getNoDuplicatesWorkInfoType } from './work-information-item-logic';


const fieldId = WORK_INFORMATION_TYPE;





const getOtherWorkInfoTypes = (params) => {
  const {
    formData,
    sectionId,
  } = params;

  const workInformationTypes = [];

  formData.formSectionsByDisplayOrder.forEach((modalSection) => {
    if (sectionId === modalSection) {
      return null;
    }
    const thisSection = formData.dataByFormSectionId[modalSection];
    const thisWorkInformationType = thisSection.dataByFieldId[fieldId].value;

    workInformationTypes.push(thisWorkInformationType);

    return null;
  });
  return workInformationTypes;
};

const workInformationTypeDuplicated = (params) => {
  const {
    otherWorkInfoTypes,
    thisWorkInformationType,
  } = params;
  return otherWorkInfoTypes.includes(thisWorkInformationType);
};



const validator = (params) => {
  const {
    values,
    field,
    formData,
    outerFormData,
    sectionId,
  } = params;
  const {
    optional,
  } = field;


  const network = currentSelectedNetwork(outerFormData);

  // gets the workInfoTypes for other instances of this modal (ie, this instances value is not included)
  const otherWorkInfoTypes = getOtherWorkInfoTypes({
    formData,
    sectionId,
  });


  const thisWorkInformationType = values[fieldId];

  const duplicatedWorkInfoType = workInformationTypeDuplicated({
    otherWorkInfoTypes,
    thisWorkInformationType,
  });

  const noDuplicatesWorkInfoType = getNoDuplicatesWorkInfoType(network, thisWorkInformationType);


  /* MAKE A DEFAULT ERRORS OBJECT */
  const errors = getDefaultFieldErrors();

  /* ERROR CHECKERS */
  const noValue = commonValidation.noValue(values[fieldId], VF_DROPDOWN);

  /* ADD ERRORS TO ERROR OBJECT */
  errors[INLINE_ERRORS].push((noValue && !optional) ? 'Please select an option' : null);
  errors[INLINE_ERRORS].push((noDuplicatesWorkInfoType && duplicatedWorkInfoType) ? 'CRQ already includes this Work Info type and only one instance can be added' : null);
  /* REMOVE BLANK ERRORS (because Formik gets confused) */
  return cleanUpFieldErrors(errors);
};


const initialValues = null;

const vFParams = {
  fieldTitle: 'Work information type',
  placeholder: 'Please select',
  optionTemplate: CATEGORISED_DROPDOWN,
};

const workInformationType = {
  id: fieldId,
  validator,
  initialValues,
  vFParams,
  fieldType: VF_DROPDOWN,
};

export {
  workInformationType,
};
